module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/spot01_american-village-ac1ff605a554e6c5b7f2d9fc910f6591.jpg";